/**
 * Significado do código de fase/rotação da estação (MV2-2006).
 *
 * Cada letra é a fase da rede em que está ligada a fase do carregador na mesma posição:
 * BCA = L1 do carregador na fase B, L2 na C e L3 na A. Monofásica: a letra é a fase da rede.
 */
export const describePhaseRotation = (phase?: string | null): string => {
  if (!phase) {
    return 'Sem fase cadastrada';
  }

  const letters = phase.split('');

  if (letters.length === 1) {
    return `Ligada na fase ${letters[0]}`;
  }

  return letters
    .map((letter, index) =>
      index === 0 ? `L1 na fase ${letter}` : `L${index + 1} na ${letter}`,
    )
    .join(', ');
};

/** Opção de select: "BCA — L1 na fase B, L2 na C, L3 na A". */
export const phaseRotationLabel = (phase: string): string =>
  `${phase} — ${describePhaseRotation(phase)}`;

/** Fases da rede em que um carro puxando `carPhases` fases pesa, a partir de L1. */
export const carGridPhases = (phase: string, carPhases?: number | null): string =>
  carPhases && carPhases > 0 && carPhases < phase.length
    ? phase.slice(0, carPhases)
    : phase;
